export const SIGNING_FLOW_DETAILS =
  'https://asigna.gitbook.io/asigna/stacks-multisig/native-stacks-approach/signing-a-transaction';
export const MAX_OWNERS_PER_SAFE = 15;
